import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "content": {
      "column": {
        "default": null,
        "name": "content",
        "null": true,
        "type": "text"
      },
      "name": "content",
      "selected_by_default": null,
      "translated": null
    },
    "content_piece_type_id": {
      "column": {
        "default": null,
        "name": "content_piece_type_id",
        "null": false,
        "type": null
      },
      "name": "content_piece_type_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "school_class_id": {
      "column": {
        "default": null,
        "name": "school_class_id",
        "null": false,
        "type": null
      },
      "name": "school_class_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SchoolClassContentPiece",
  "collectionKey": "school_class_content_pieces",
  "collectionName": "school_class_content_pieces",
  "i18nKey": "school_class_content_piece",
  "camelizedLower": "schoolClassContentPiece",
  "name": "SchoolClassContentPiece",
  "nameDasherized": "school-class-content-piece",
  "pluralName": "school_class_content_pieces",
  "ransackable_associations": [
    {
      "className": "SchoolClassContentPiece::Audit",
      "collectionName": "school_class_content_piece_audits",
      "foreignKey": "school_class_content_piece_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolClassContentPieceAudit",
      "through": null
    },
    {
      "className": "ContentPieceType",
      "collectionName": "content_piece_types",
      "foreignKey": "content_piece_type_id",
      "name": "content_piece_type",
      "macro": "belongs_to",
      "resource_name": "ContentPieceType",
      "through": null
    },
    {
      "className": "SchoolClassContentPiece::Audit",
      "collectionName": "school_class_content_piece_audits",
      "foreignKey": "school_class_content_piece_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolClassContentPieceAudit",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "content",
      "column": {
        "default": null,
        "name": "content",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "content_piece_type_id",
      "column": {
        "default": null,
        "name": "content_piece_type_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "school_class_id",
      "column": {
        "default": null,
        "name": "school_class_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "latest_for_school_class"
    }
  ],
  "relationships": [
    {
      "className": "ContentPieceType",
      "collectionName": "content_piece_types",
      "foreignKey": "content_piece_type_id",
      "name": "content_piece_type",
      "macro": "belongs_to",
      "resource_name": "ContentPieceType",
      "through": null
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "belongs_to",
      "resource_name": "SchoolClass",
      "through": null
    }
  ],
  "paramKey": "school_class_content_piece",
  "primaryKey": "id"
}

/** Frontend model for SchoolClassContentPiece. */
class SchoolClassContentPiece extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  content() {
    return this.readAttributeUnderscore("content")
  }

  /** @returns {boolean} */
  hasContent() {
    const value = this.content()

    return this._isPresent(value)
  }

  /** @returns {any} */
  contentPieceTypeId() {
    return this.readAttributeUnderscore("content_piece_type_id")
  }

  /** @returns {boolean} */
  hasContentPieceTypeId() {
    const value = this.contentPieceTypeId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  schoolClassId() {
    return this.readAttributeUnderscore("school_class_id")
  }

  /** @returns {boolean} */
  hasSchoolClassId() {
    const value = this.schoolClassId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./content-piece-type.js").default | null} */
  contentPieceType() {
    return this._readBelongsToReflection({reflectionName: "content_piece_type"})
  }

  /** @returns {Promise<import("./content-piece-type.js").default | null>} */
  loadContentPieceType() {
    if (!("contentPieceTypeId" in this)) throw new Error("Foreign key method wasn't defined: contentPieceTypeId")

    const id = this.contentPieceTypeId()
    const modelClass = modelClassRequire("ContentPieceType")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "content_piece_type", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./school-class.js").default | null} */
  schoolClass() {
    return this._readBelongsToReflection({reflectionName: "school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadSchoolClass() {
    if (!("schoolClassId" in this)) throw new Error("Foreign key method wasn't defined: schoolClassId")

    const id = this.schoolClassId()
    const modelClass = modelClassRequire("SchoolClass")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "school_class", model: this, modelClass},
      {ransack}
    )
  }
}

export default SchoolClassContentPiece
